import { Component, NgZone, OnInit, OnChanges, AfterViewInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AuthService } from "../../shared/services/auth.service";
import { Router } from '@angular/router';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { MessageService } from '../../shared/services/messages.service';
import { FaceRecognitionService } from '../../shared/services/face-recognition.service';
import { FaceRecognitionResponse } from '../../shared/models/face.model';
import { DesktopCameraService } from '../../shared/services/desktop-camera.service';

import { FormBuilder, FormGroup } from '@angular/forms';
import {MenuItem} from 'primeng/api';

export interface Item { name: string;}

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})

export class AdminDashboardComponent implements OnInit, AfterViewInit{
  imageString = '';
  faceApiResponse: Observable<FaceRecognitionResponse>;
  subscriptionKey: string;
  serviceReturn: any;
  menuitems: MenuItem[];

  private itemsCollection: AngularFirestoreCollection<Item>;
  private usersCollection: AngularFirestoreCollection<Item>;
  private itemsDoc: AngularFirestoreDocument<Item>;
  public personGroups = [];
  public personsByGroup = [];
  public personsIdentify = [];
  public identifiedPersons = [];
  items: Observable<Item[]>;
  users: any;
  logs: any;
  checkInTime: string;
  checkOutTime: string;
  selectedId: any;
  selectedPersonId: any;

  // Views
  isShown: boolean = false;
  display: boolean = false;
  displayCompany: boolean = false;
  displayCompanyPersons: boolean = false;
  displayPersonsUrl: boolean = false;
  displayResponse: boolean = false;

  companyForm: FormGroup;
  companyPersonsForm: FormGroup;
  personsUrlForm: FormGroup;

  constructor(
    public authService: AuthService,
    public router: Router,
    public ngZone: NgZone,
    public faceRecognitionService: FaceRecognitionService,
    private afs: AngularFirestore,
    private cameraService: DesktopCameraService,
    private messageService: MessageService,
    private httpClient: HttpClient,
    private companyAddGroup: FormBuilder,
    private personAddForm: FormBuilder,
    private personAddUrlForm: FormBuilder,
  ) { 
    this.itemsCollection = afs.collection<Item>('logs/', ref => ref.orderBy('time', "desc"));
    this.items = this.itemsCollection.valueChanges();
    this.itemsCollection.valueChanges()
    .subscribe(
      data => this.logs = data.length
    );

    this.usersCollection = afs.collection<Item>('users/');
    this.usersCollection.valueChanges()
    .subscribe(
      data => this.users = data.length
    );
  }

  // Procces Image
  processImage(faceId) {
    if (!this.subscriptionKey) {
      return;
    }

    // Date and Time - Check-In/Check-Out
    this.checkInTime = new Date().toJSON("yyyy/MM/dd HH:mm");
    this.checkOutTime = new Date().toJSON("yyyy/MM/dd HH:mm");

    this.faceApiResponse = this.cameraService.getPhoto().pipe(
      switchMap((base64Image: string) => {
        this.imageString = base64Image;
        return this.faceRecognitionService.scanImage(
          this.subscriptionKey,
          base64Image
        );
      })
    );
  }

  detectApiResponse(response){
    const detectResponse = response;
    this.faceRecognitionService.detectApiMethod(response);
 }

 ngAfterViewInit(){
  this.menuitems = [
    {label: 'Status: Online', icon: 'pi pi-fw pi-plus'},
    {label: 'Help Centre', icon: 'pi pi-fw pi-download', routerLink: ['/help-centre']},
    {label: 'Logout', icon: 'pi pi-fw pi-refresh', command: () => this.authService.SignOut()}
]
}

  ngOnInit() {
    this.faceRecognitionService.getPersonGroups().subscribe(data => this.personGroups = data);
    // this.faceRecognitionService.getPersonsByGroup().subscribe(data => this.personsByGroup = data);

    //Forms
    this.companyForm = this.companyAddGroup.group({
      id: '',
      name: '',
    });

    this.companyPersonsForm = this.personAddForm.group({
      id: '',
      name: '',
    });

    this.personsUrlForm = this.personAddUrlForm.group({
      url: '',
    });

    this.messageService.clear();
}

companyChange(event: any){
  console.log(event.target.value);
  this.faceRecognitionService.getPersonsByGroup(event.target.value).subscribe(data => this.personsByGroup = data);
  this.isShown = true;
  this.selectedId = event.target.value;
}

personChange(event: any){
  console.log(event.target.value);
  this.selectedPersonId = event.target.value;
}

addPersonGroup(){
  console.log(this.companyForm.value.id);
  this.faceRecognitionService.addPersonGroup(this.companyForm.value.id, this.companyForm.value.name);
}

addPerson(){
  console.log(this.companyForm.value.id);
  console.log(this.selectedId, this.companyPersonsForm.value.id, this.companyPersonsForm.value.name);
  this.faceRecognitionService.addPerson(this.selectedId, this.companyPersonsForm.value.id, this.companyPersonsForm.value.name);
}

addPersonFace(){
  console.log(this.companyForm.value.id);
  console.log(this.selectedId, this.selectedPersonId, this.personsUrlForm.value.url);
  this.faceRecognitionService.addPersonFace(this.selectedId, this.selectedPersonId, this.personsUrlForm.value.url);
}

deletePersonGroup(){
  console.log(this.selectedId);
  this.faceRecognitionService.deletePersonGroup(this.selectedId)
}

deletePerson(){
  console.log(this.selectedPersonId);
  this.faceRecognitionService.deletePerson(this.selectedId, this.selectedPersonId)
}

trainGroup(){
  this.faceRecognitionService.trainGroup(this.selectedId);
}

trainingStatus(){
  this.faceRecognitionService.trainingStatus(this.selectedId);
}

reset(){
  this.messageService.clear();
}

resetForm(){
  ;
}


//Show Forms
showCompanyForm(){
  this.displayPersonsUrl = false;
  this.displayCompanyPersons = false;
  this.display = true;
  this.displayCompany = true;
} 

showCompanyPersonsForm(){
  this.displayPersonsUrl = false;
  this.displayCompany = false;
  this.display = true;
  this.displayCompanyPersons = true;
}

showPersonsUrl(){
  this.displayCompanyPersons = false;
  this.displayCompany = false;
  this.display = true;
  this.displayPersonsUrl = true;
}

showResponse(){
  this.displayResponse = !this.displayResponse;
}

// showPersonsUrlForm(){
// }

  
}
